import api from '../../../services/api';

export const evolutionService = {
  getEvolution: () => api.get('/transactions/evolution'),
  toggleCheck: (classifierId: string, month: string, field: string, value: boolean) =>
    api.patch('/transactions/evolution-check', { classifierId, month, field, value }),
};
